import { differenceInCalendarDays } from "date-fns";

/** Whole calendar days left in a trial, floored at 0. */
export function trialDaysRemaining(
  currentPeriodEnd: string | null | undefined,
  now: Date = new Date(),
): number | undefined {
  if (!currentPeriodEnd) return undefined;
  const end = new Date(currentPeriodEnd);
  if (Number.isNaN(end.getTime())) return undefined;
  return Math.max(0, differenceInCalendarDays(end, now));
}

/** Mid-sentence phrasing: "Free trial · 6 days left", "Trial ends … · last day". */
export function formatTrialDaysRemaining(
  days: number | undefined,
): string | null {
  if (days === undefined) return null;
  if (days === 0) return "last day";
  return days === 1 ? "1 day left" : `${days} days left`;
}
